import {useCallback, useState, useEffect} from "react";
import './UploadImageComponent.scss';
import FilePickerComponent from "../file-picker/FilePickerComponent";
import {ImageConfig} from "../../constants";
import {CommonService} from "../../services";

interface UploadImageComponentProps {
    selectedFiles: any;
    isEdit?: boolean;
    onClick: (file: any) => void;
    onBlur?: () => void;
}

const UploadImageComponent = (props: UploadImageComponentProps) => {
    const {selectedFiles, onClick, onBlur} = props;
    const [selectedFile, setSelectedFile] = useState<any>(selectedFiles);

    // Sync local state with props when they change
    useEffect(() => {
        setSelectedFile(selectedFiles);
    }, [selectedFiles]);

    const deleteImageHandler = useCallback(() => {
        CommonService.onConfirm(
            {
                confirmationTitle: `Delete File`,
                confirmationDescription: `Are you sure you want to Delete File?`,
                no: {
                    color: "primary",
                    text: "No",
                    variant: "outlined"
                },
                yes: {
                    color: "error",
                    text: "Yes",
                    variant: "contained",
                }
            }
        ).then(() => {
            setSelectedFile(null);
            onClick(null); // Notify parent component
        }).catch((err) => {
            console.log(err, 'err')
        })
    }, [onClick]);

    // Helper function to safely create object URL
    const createSafeObjectURL = (file: any) => {
        if (!file) return '';

        // If it's already a URL string (for edit mode), return as is
        if (typeof file === 'string') return file;

        // If it's a File or Blob object, create object URL
        if (file instanceof File || file instanceof Blob) {
            return URL.createObjectURL(file);
        }

        return '';
    };

    return (
        <div className={'upload-image-component'} onClick={onBlur}>
            {selectedFile === null ? (
                <div className={'photo-upload-bg'}>
                    <div className="upload-modal">
                        <FilePickerComponent
                            multiple={false}
                            maxFileCount={1}
                            uploadText={'Click or drag file to this area to upload'}
                            maxFileSize={500}
                            acceptedFilesText={'Max size: 4MB | File extensions: .jpg .png .pdf'}
                            acceptedFileTypes={["jpg", "png", "pdf", "jpeg"]}
                            showDropZone={true}
                            onFilesDrop={(acceptedFiles, rejectedFiles) => {
                                if (rejectedFiles.length > 0) {
                                    setSelectedFile(null);
                                } else {
                                    setSelectedFile(acceptedFiles[0]);
                                    onClick(acceptedFiles[0]);
                                }
                            }}
                        />
                    </div>
                </div>
            ) : (
                <div className={'uploaded-image-alignment'}>
                    <img
                        src={createSafeObjectURL(selectedFile)}
                        alt={'thumbnail'}
                        className={'photo-display'}
                    />
                    <div>{selectedFile?.name}</div>
                    <ImageConfig.DeleteIcon
                        className={'icon-button'}
                        color={'red'}
                        onClick={() => {
                            deleteImageHandler()
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default UploadImageComponent;